import React, { useState, useEffect } from 'react';
import { Form, Button, Input, message, InputNumber, Select, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import InputRules from '../../data/InputRules';
import { connect } from 'react-redux';
import { Actions } from '../../store/actions';
import { toFormData } from '../../util/FormData';

const layout = {
	labelCol: {
		span: 6,
	},
	wrapperCol: {
		span: 8,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 6,
		span: 16,
	},
};
const uploadButton = (
	<div>
		<PlusOutlined />
		<div style={{ marginTop: 8 }}>Upload</div>
	</div>
);

const PackagePostForm = ({ addPackage, services }) => {
	const [filelist, setFileList] = useState([]);
	const [imageList, setImageList] = useState([]);

	useEffect(() => {
		if (filelist.length) {
			const file = filelist[filelist.length - 1].originFileObj;
			file.thumbUrl = URL.createObjectURL(file);
			const list = imageList;
			list.push(file);
			setImageList(list);
		}
	}, [filelist]);

	const onFinish = (values) => {
		values.image = imageList[0];
		const data = toFormData(values);
		addPackage(data);
	};
	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};
	const handleChange = ({ fileList }) => {
		setFileList(fileList);
	};

	return (
		<Form
			{...layout}
			name="PackageForm"
			initialValues={{ remember: true }}
			onFinish={onFinish}
			onFinishFailed={onFinishFailed}
		>
			<Form.Item label="Name" name={['name']} rules={InputRules.required('Please enter name!')}>
				<Input placeholder="Enter package name" />
			</Form.Item>
			<Form.Item label="Slug" name={['slug']} rules={InputRules.required('Please enter slug!')}>
				<Input placeholder="Enter slug" />
			</Form.Item>
			{/* <Form.Item
				label="Description"
				name={['description']}
				rules={InputRules.required('Please enter package description!')}
			>
				<Input placeholder="Enter package description" />
			</Form.Item> */}
			<Form.Item label="Price" name={['price']} rules={InputRules.required('Please enter Price!')}>
				<InputNumber placeholder="Enter price for package" />
			</Form.Item>
			{/* <Form.Item label="Discount" name={['discount']} rules={InputRules.required('Please enter discount')}>
				<InputNumber placeholder="Enter discount rate" />
			</Form.Item> */}
			{/* <Form.Item label="Service Type" name={['serviceType']} rules={InputRules.required('Please service type!')}>
				<Input placeholder="Enter Service Type" />
			</Form.Item> */}
			<Form.Item label="Key Points" name={['perks']} rules={InputRules.required('Please select perks!')}>
				<Select showSearch allowClear={true} placeholder="Select key points" mode="tags">
					<Select.Option></Select.Option>
				</Select>
			</Form.Item>
			<Form.Item label="Services" name={['services']} rules={InputRules.required('Please select services!')}>
				<Select showSearch allowClear={true} placeholder="Select services" mode="tags">
					{services.map((service) => {
						return (
							<Select.Option value={service?._id} key={service?._id}>
								{service?.id}
							</Select.Option>
						);
					})}
				</Select>
			</Form.Item>
			<Form.Item label="Upload Image" name="image" rules={InputRules.required('Please enter image!')}>
				<Upload
					accept=".jpg,.png,.jpeg"
					listType="picture-card"
					onChange={handleChange}
					fileList={filelist}
					beforeUpload={() => false}
					maxCount={1}
				>
					{uploadButton}
				</Upload>
			</Form.Item>
			<Form.Item
				label="Primary Button Label"
				name={['primaryActionText']}
				rules={InputRules.required('Please enter label for primary button!')}
			>
				<Input placeholder="Enter primary action label" />
			</Form.Item>
			<Form.Item
				label="Primary Button Link"
				name={['primaryActionHref']}
				rules={InputRules.required('Please enter href for primary button!')}
			>
				<Input placeholder="Enter primary action href" />
			</Form.Item>
			<Form.Item {...tailLayout}>
				<Button type="primary" htmlType="submit">
					Add Package
				</Button>
			</Form.Item>
		</Form>
	);
};

const mapStateToProps = (store) => ({
	services: store.service.services,
});

const mapDispatchToProps = (dispatch) => ({
	addPackage: (body) => dispatch(Actions.addPackage(body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PackagePostForm);
